module.exports = __webpack_public_path__ + "img/logo.d654b77c.png";